import axios from 'axios';
import { Paginated } from '../../common/types';
import { ADMIN_STRAW_STAGE_CONTENTS_ROUTE } from '../../api/backend';
import { StrawStageContent } from '../../common/model/dto/straw-stage-content';

export const loadStrawStageContents = async (query: string) => {
  const { data } = await axios.get<Paginated<StrawStageContent>>(
    `${ADMIN_STRAW_STAGE_CONTENTS_ROUTE}?${query}`
  );

  return data;
};

export const getStrawStageContentById = async (id: string) => {
  const { data } = await axios.get<StrawStageContent>(
    `${ADMIN_STRAW_STAGE_CONTENTS_ROUTE}/${id}`
  );

  return data;
};

export const updateStrawStageContentById = async (
  strawStageContentId: string,
  updateObj: Partial<StrawStageContent>
): Promise<void> => {
  await axios.patch<StrawStageContent>(
    `${ADMIN_STRAW_STAGE_CONTENTS_ROUTE}/${strawStageContentId}`,
    updateObj
  );
};
